import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./styles.scss";

const Loading: React.FC = () => {
  return (
    <div className="wrapper">
      <CircularProgress />
    </div>
  );
};

export default Loading;
